export enum EmptyTemplatesStateTypes {
  NoTemplates = "NoTemplates",
  EmptySearch = "EmptySearch",
  NoOwned = "NoOwned",
  NoShared = "NoShared",
}
